import styled from 'styled-components';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
`;

export const DateWrapper = styled.div<{ $isToday: boolean }>`
  width: 46px;
  flex-shrink: 0;
  border-radius: 8px;
  padding: 12px 0;
  background: ${({ $isToday, theme }) => ($isToday ? theme.colors.green1 : theme.colors.black2)};
  border: 1px solid
    ${({ $isToday, theme }) => ($isToday ? theme.colors.green6 : theme.colors.black3)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

export const DateDayWrapper = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  font-style: normal;
  color: ${({ theme }) => theme.colors.black9};
`;

export const DateMonthWrapper = styled.div`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const EventsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 0 15px 0 0;
`;
